module.exports = "pegasus/assets/trans-checker.png";